import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { UsersNotificationsNotificationSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/users_notifications';

import type { AnyObject } from '../../types/common';
import type { UserNotificationsAppState } from './types';

export const initialState: UserNotificationsAppState = {
  newItemsCount: 0,
  relations: {},
  relationsUpdateTime: Infinity,
  webSocketInitialized: false,
};

export const userNotificationsSlice = createSlice({
  name: 'user_notifications',
  initialState,
  reducers: {
    setUserNotifications: (
      state,
      action: PayloadAction<
        UsersNotificationsNotificationSchemaWithIdNullable[]
      >,
    ) => {
      state.items = action.payload;
    },

    addUserNotification: (
      state,
      action: PayloadAction<UsersNotificationsNotificationSchemaWithIdNullable>,
    ) => {
      state.items = [...(state.items ?? []), action.payload];
    },

    setUserNotificationsRelations: (
      state,
      action: PayloadAction<Record<string, AnyObject>>,
    ) => {
      Object.assign(state.relations, action.payload);
    },

    setUserNotificationsRelationsUpdateTime: (
      state,
      action: PayloadAction<number>,
    ) => {
      state.relationsUpdateTime = action.payload;
    },

    setUserNotificationsCounter: (state, action: PayloadAction<number>) => {
      state.newItemsCount = action.payload;
    },

    decrementUserNotificationsCounter: (state) => {
      state.newItemsCount -= 1;
    },

    markUserNotificationsAsRead: (state, action: PayloadAction<string[]>) => {
      state.items?.forEach((item) => {
        if (item.id && action.payload.includes(item.id)) {
          item.status = 'READ';
        }
      });
    },

    setUserNotificationsWebSocketInitialized: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.webSocketInitialized = action.payload;
    },
  },
});

export const {
  addUserNotification,
  decrementUserNotificationsCounter,
  markUserNotificationsAsRead,
  setUserNotifications,
  setUserNotificationsCounter,
  setUserNotificationsRelations,
  setUserNotificationsRelationsUpdateTime,
  setUserNotificationsWebSocketInitialized,
} = userNotificationsSlice.actions;

export const userNotificationsReducer = userNotificationsSlice.reducer;
